import React, { useCallback, useState, useEffect, useMemo} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import history from "../../../../libs/history.utils";
import RouteName from "../../../../routes/Route.name";
import {actionFetchSubscription} from "../../../../actions/Reward.action";

const useAppProgramsTable = ({ listData }) => {
  const dispatch = useDispatch();
  const [allData, setAllData] = useState([]);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentData, setCurrentData] = useState([]);
  const [editData, setEditData] = useState(null);
  const [totalShow, setTotalShow] = useState(10);
  // const [isFetching, setIsFetching] = useState(false);
  const [isDialog, setIsDialog] = useState(false);
  const { id } = useParams();

  const {
    sorting_data: sortingData,
    is_fetching: isFetching,
    query,
    query_data: queryData,
    all,
  } = useSelector((state) => state?.appusers);

  useEffect(() => {
    if (listData?.length > 0) {
      setAllData(listData);
      setData(listData);
    }
  }, [listData]);

  const toggleDialog = useCallback(
    (data) => {
      setIsDialog((e) => !e);
      if (data?.id) {
        setEditData(data);
      } else {
        setEditData(null);
      }
    },
    [editData, isDialog]
  );

  const _processData = () => {
    const from = currentPage * totalShow - totalShow;
    let to = currentPage * totalShow;
    if (from <= data.length) {
      to = to <= data.length ? to : data.length;
      setCurrentData(data.slice(from, to));
    }
  };
  useEffect(() => {
    // initData();
    _processData();
  }, [currentPage, data]);

  // const queryFilter = useCallback((key, value) => {
  //   console.log("_queryFilter", key, value);
  // }, []);
  const queryFilter = useCallback(
    (key, value) => {
      dispatch(
        actionFetchSubscription(1, sortingData, {
          query: key == "SEARCH_TEXT" ? value : query,
          query_data: key == "FILTER_DATA" ? value : queryData,
          user_id: id,
        })
      );
    },
    [sortingData, query, queryData]
  );

  // const handleSearchValueChange = useCallback(
  //   (value) => {
  //     console.log("_handleSearchValueChange", value);
  //     queryFilter("SEARCH_TEXT", value);
  //     if (value) {
  //       const tempData = data.filter((val) => {
  //         if (
  //           val?.candidate?.name?.match(new RegExp(value, "ig")) ||
  //           val?.candidate?.email?.match(new RegExp(value, "ig"))
  //         ) {
  //           return val;
  //         }
  //       });
  //       setData(tempData);
  //     } else {
  //       setData(data);
  //     }
  //   },
  //   [queryFilter, _processData, data, setData]
  // );

  const handleSearchValueChange = useCallback(
    (value) => {
      const dataIds = new Set(data?.map((item) => item?.id));
      const mergedArray = [
        ...data,
        ...allData?.filter((item) => !dataIds?.has(item?.id)),
      ];
      if (value) {
        const tempData = mergedArray?.filter((val) => {
          if (val?.name?.match(new RegExp(value, "ig"))) {
            return val;
          }
        });
        setData(tempData);
      } else {
        setData(mergedArray);
      }
    },
    [data, setData, allData]
  );

  const handlePageChange = useCallback(
    (type) => {
      console.log("_handlePageChange", type);
      if (Math.ceil(data.length / totalShow) >= type + 1) {
        setCurrentPage(type + 1);
        _processData();
      }
    },
    [_processData, setCurrentPage, data, totalShow]
  );

  const handleFilterDataChange = useCallback(
    (value) => {
      console.log(value, "va")
        // queryFilter("FILTER_DATA", value);
        const filterValue = value.length && value[0]?.value;
        console.log(data, "filter")
          const dataIds = new Set(data?.map((item) => item?.id));
          const mergedArray = [
            ...data,
            ...allData?.filter((item) => !dataIds?.has(item?.id)),
          ];
          if (filterValue) {
            // const tempData = mergedArray?.filter((filterValue) => {
            //   if (filterValue?.name?.match(new RegExp(filterValue, "ig"))) {
            //     return filterValue;
            //   }
            // });
            //const isActiveFilter = filterValue === "active";
            const tempData = mergedArray.filter((item) => item.status === filterValue);
            setData(tempData);
          } else {
            setData(mergedArray);
          }
        
        
    },
    [queryFilter, data, setData, allData]
);

  const handleSortOrderChange = useCallback((row, order) => {
    console.log(`handleSortOrderChange key:${row} order: ${order}`);
  }, []);

  const handleRowSize = (page) => {
    console.log(page);
  };

  const configFilter = useMemo(() => {
    return [
      {
        label: "Status",
        name: "status",
        type: "select",
        fields: ["INACTIVE", "ACTIVE"],
       
      },
     
    ];
  }, [listData]);

  const handleProgramClick = (data) => {
    history.push(`${RouteName.PROGRAM_DETAIL}${ data?.id }`);
  };


  return {
    handleSortOrderChange,
    handleRowSize,
    handlePageChange,
    data,
    currentData,
    currentPage,
    isFetching,
    isDialog,
    toggleDialog,
    editData,
    handleSearchValueChange,
    handleFilterDataChange,
    configFilter,
    handleProgramClick
  };
};

export default useAppProgramsTable;
